export const ToothFdiValues: number[] = [
  18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28, 38, 37, 36, 35, 34, 33, 32, 31, 41, 42, 43, 44, 45,
  46, 47, 48,
];

export const ToothNamesByNumbers: any[] = [
  { toothName: 'central-incisor', toothNumbers: [8, 9, 24, 25] },
  { toothName: 'lateral-incisor', toothNumbers: [7, 10, 23, 26] },
  { toothName: 'canine', toothNumbers: [6, 11, 22, 27] },
  { toothName: 'first-premolar', toothNumbers: [5, 12, 21, 28] },
  { toothName: 'second-premolar', toothNumbers: [4, 13, 20, 29] },
  { toothName: 'first-molar', toothNumbers: [3, 14, 19, 30] },
  { toothName: 'second-molar', toothNumbers: [2, 15, 18, 31] },
  { toothName: 'third-molar', toothNumbers: [1, 16, 17, 32] },
];
